<template>
    <div class="holiday-countdown">
        <div class="container">
            <h1 class="title">时间倒计时</h1>
            <div class="countdown-item">
                <span class="item-name">距离休息日：</span>
                <span class="item-days">{{ nextWeekend }}</span>
                <span class="item-unit">天</span>
            </div>
            <div class="countdown-item">
                <span class="item-name">距离发薪日：</span>
                <span class="item-days">{{ payday }}</span>
                <span class="item-unit">天</span>
            </div>
            <div class="countdown-item">
                <span class="item-name">距离清明节：</span>
                <span class="item-days">{{ qingming }}</span>
                <span class="item-unit">天</span>
            </div>
            <div class="countdown-item">
                <span class="item-name">距离劳动节：</span>
                <span class="item-days">{{ laborDay }}</span>
                <span class="item-unit">天</span>
            </div>
        </div>
        <div class="footer">数据实时更新，按自然日计算</div>
    </div>
</template>

<script>
export default {
    name: "holidayComponent",
    data() {
        return {
            nextWeekend: 0,
            payday: 0,
            qingming: 0,
            laborDay: 0,
            updateTimer: null, // 定时器标识
        };
    },
    methods: {
        // 工具函数：计算两个日期之间的天数差
        getDaysDiff(targetDate, currentDate = new Date()) {
            const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
            // 统一时间为0点，避免时分秒影响计算
            const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            const target = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
            const diffDays = Math.ceil((target - current) / oneDay);
            return diffDays < 0 ? 0 : diffDays; // 负数则显示0天（已过）
        },

        // 1. 计算距离下个周末（周六）的天数
        calcNextWeekend() {
            const now = new Date();
            const dayOfWeek = now.getDay(); // 0(周日) - 6(周六)
            // 计算到下周六的天数：如果今天是周六，下周六是7天后；否则是 6 - 当前星期数
            const daysToWeekend = dayOfWeek === 6 ? 7 : 6 - dayOfWeek;
            this.nextWeekend = daysToWeekend;
        },

        // 2. 计算距离每月10号发薪日的天数
        calcPayday() {
            const now = new Date();
            const currentDay = now.getDate();
            const currentMonth = now.getMonth();
            const currentYear = now.getFullYear();

            let paydayDate;
            // 如果当前日期超过10号，计算下个月10号
            if (currentDay > 10) {
                // 处理12月的情况（月份从0开始）
                const nextMonth = currentMonth === 11 ? 0 : currentMonth + 1;
                const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
                paydayDate = new Date(nextYear, nextMonth, 10);
            } else {
                paydayDate = new Date(currentYear, currentMonth, 10);
            }

            this.payday = this.getDaysDiff(paydayDate);
        },

        // 3. 计算距离清明节的天数（清明节是4月4-6日，固定按4月5日计算）
        calcQingming() {
            const now = new Date();
            const currentYear = now.getFullYear();
            // 清明节固定按4月5日计算（实际每年略有差异，如需精准可扩展）
            const qingmingDate = new Date(currentYear, 3, 5); // 月份从0开始，3=4月

            // 如果今年清明节已过，计算明年的
            if (qingmingDate < now) {
                qingmingDate.setFullYear(currentYear + 1);
            }

            this.qingming = this.getDaysDiff(qingmingDate);
        },

        // 4. 计算距离劳动节的天数（5月1日）
        calcLaborDay() {
            const now = new Date();
            const currentYear = now.getFullYear();
            const laborDayDate = new Date(currentYear, 4, 1); // 4=5月

            // 如果今年劳动节已过，计算明年的
            if (laborDayDate < now) {
                laborDayDate.setFullYear(currentYear + 1);
            }

            this.laborDay = this.getDaysDiff(laborDayDate);
        },

        // 初始化所有倒计时
        initCountdown() {
            this.calcNextWeekend();
            this.calcPayday();
            this.calcQingming();
            this.calcLaborDay();
        },
    },
    mounted() {
        // 页面挂载后初始化倒计时
        this.initCountdown();
        // 每小时更新一次（避免日期切换导致数据错误）
        this.updateTimer = setInterval(() => {
            this.initCountdown();
        }, 3600000);
    },
    beforeDestroy() {
        // 组件销毁前清除定时器，防止内存泄漏
        if (this.updateTimer) {
            clearInterval(this.updateTimer);
        }
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Microsoft YaHei", Arial, sans-serif;
}

.holiday-countdown {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.container {
    width: 100%;
    max-width: 600px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    padding: 30px;
    margin-top: 50px;
}

.title {
    text-align: center;
    font-size: 24px;
    color: #333;
    margin-bottom: 30px;
    font-weight: 600;
}

.countdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
}

.countdown-item:last-child {
    border-bottom: none;
}

.item-name {
    font-size: 18px;
    color: #555;
}

.item-days {
    font-size: 22px;
    font-weight: bold;
    color: #409eff;
}

.footer {
    margin-top: 30px;
    text-align: center;
    color: #999;
    font-size: 14px;
}

/* 响应式适配 */
@media (max-width: 480px) {
    .container {
        padding: 20px;
        margin-top: 20px;
    }

    .title {
        font-size: 20px;
    }

    .item-name {
        font-size: 16px;
    }

    .item-days {
        font-size: 18px;
    }
}
</style>
